import { ReactComponent as Close } from 'assets/header/close.svg'

interface ITermsModal {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    title: string
    content: string
}

const TermsModal = ({ isOpen, setIsOpen, title, content }: ITermsModal) => {
    const close = () => {
        setIsOpen(false)
    }

    if (!isOpen) return null;

    return (
        <div className="z-[100] fixed">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg rounded-lg w-[1000px] mobile:w-full max-h-[80vh] overflow-y-auto">
                    <div className='flex flex-col gap-6 px-6 mobile:px-4 pb-6 font-semibold text-center'>
                        <div className="top-0 sticky flex justify-between items-center gap-3 bg-white py-6 w-full">
                            <p className='mobile:text-lg text-2xl'>{title}</p>
                            <Close
                                className='cursor-pointer'
                                onClick={() => {
                                    close();
                                }}
                            />
                        </div>
                        <div className="text-left" dangerouslySetInnerHTML={{ __html: content }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsModal;